<template>
  <div class="propertyapp">
    <div class="header">
      <div class="title">业主APP</div>
      <div class="border"></div>
    </div>
    <div class="body">
      <div class="box">
        <div class="left">
          <div class="list">
            <div class="item" v-for="item in propertyappList" :key="item.id">
              <img :src="item.logo" alt="" />
              <div class="title">{{ item.title }}</div>
              <div class="text">{{ item.text }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import ownerapp1 from "../../../../assets/product/ownerapp1.png";
import ownerapp2 from "../../../../assets/product/ownerapp2.png";
import ownerapp3 from "../../../../assets/product/ownerapp3.png";
import ownerapp4 from "../../../../assets/product/ownerapp4.png";
import ownerapp5 from "../../../../assets/product/ownerapp5.png";
import ownerapp6 from "../../../../assets/product/ownerapp6.png";

export default {
  setup() {
    return reactive({
      propertyappList: [
        {
          id: 1,
          title: "报事报修",
          text: "日常生活遇到问题，一键报修，迅速匹配维修人员，上门服务，无需等待。",
          logo: ownerapp1,
        },
        {
          id: 2,
          title: "一键开门",
          text: "有朋自远方来，一键申请，快速通行。",
          logo: ownerapp2,
        },
        {
          id: 3,
          title: "便民服务",
          text: "各种组团活动，一键参加，让业主生活更加多姿多彩。",
          logo: ownerapp3,
        },
        {
          id: 4,
          title: "停车充电",
          text: "剩余停车位，有无充电桩，一键查询，不再烦恼。",
          logo: ownerapp4,
        },
        {
          id: 5,
          title: "物业缴费",
          text: "随时随地在线完成水电费、物业费、停车费等日常费用的缴纳，方便快捷。",
          logo: ownerapp5,
        },
        {
          id: 6,
          title: "智能监控",
          text: "云端监控，实时对讲，让社区更安全。",
          logo: ownerapp6,
        },
      ],
    });
  },
};
</script>

<style scoped>
.propertyapp {
  margin: 24px auto;
}
.header {
  width: 100%;
  margin: 0 auto;
}
.header .title {
  font-size: 16px;
  text-align: center;
  margin-top: 24px;
}
.header .border {
  width: 16px;
  height: 2px;
  background: #248efb;
  margin: 4px auto 0;
}

.body .box {
  width: 92vw;
  margin: 0 auto;
  padding: 16px 0;
  text-align: center;
}
.body .box .right img {
  width: 282px;
}
.body .box .left .list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.body .box .left .list .item {
  width: 162px;
  text-align: center;
  margin: 16px auto;
}
.body .box .left .list .item img {
  width: 36px;
}
.body .box .left .list .item .title {
  font-size: 14px;
  margin-top: 12px;
  font-weight: 600;
}
.body .box .left .list .item .text {
  font-size: 12px;
  margin-top: 8px;
  color: #495a6c;
}
</style>
